<template>
  <div :class="$style.home">
    <div :class="$style.home__animation">
      <Animation path="/anim/homeAnimation.json" />
    </div>
    <main :class="$style.home__content">
      <div :class="$style.logoContainer">
        <WordguruLogo
          :class="$style.logo"
          data-test="logo"
        />
        <span>from</span>
        <a
          href="https://www.netguru.co/"
          target="_blank"
          rel="noopener"
          title="Netguru"
        >
          <NetguruLogo :class="$style.netguruLogo" />
        </a>
      </div>
      <button
        class="btn btnPrimary"
        :class="$style.home__button"
        @click="getStarted"
      >
        {{ $t("views.home.get_started") }}
      </button>
    </main>
  </div>
</template>

<script>
import Animation from '@/components/Animation/Animation';
import WordguruLogo from '@/assets/logo.svg';
import NetguruLogo from '@/assets/netguru.svg';

export default {
  components: {
    Animation,
    WordguruLogo,
    NetguruLogo,
  },

  computed: {
    getStartedRouteName() {
      return this.$store.state.onboarding.isFinished
        ? 'setup'
        : 'onboarding';
    },
  },

  methods: {
    getStarted() {
      this.$_playSound();
      this.$router.push({ name: this.getStartedRouteName });
    },
  },
};
</script>

<style module lang="scss">
  .home {
    position: relative;
    height: 100%;

    &__content {
      position: relative;
      display: flex;
      height: 100%;
      padding: 0 rem(10px) rem(40px);
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    &__animation {
      @include absolute(top 0);
      @include sizing(100%);
    }

    &__button {
      animation: slidein 4s ease-out;
    }
  }

  .logoContainer {
    display: flex;
    width: 268px;
    max-width: 90%;
    margin-top: 17vh;
    color: $c-white;
    flex-direction: column;
    align-items: center;

    span {
      margin: -10px 0 15px;
      font-size: $fs-usmall;
      font-weight: $fw-bold;
      letter-spacing: 1.5px;
      text-transform: uppercase;
    }
  }

  .logo {
    width: 100%;
  }

  .netguruLogo {
    color: $c-white;
  }

  @keyframes slidein {
    0% {
      opacity: 0;
      transform: translateY(100px);
    }

    60% {
      opacity: 0;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
